import styled from "styled-components";
import flexContainer, { FlexContainerProps } from "../../Styled/flexContainer";
import Box from "../Box";

const Flex = styled(Box)<FlexContainerProps>`
  ${flexContainer};
`;

export default Flex;
